import { create } from 'zustand';
import { useMultiFloorStateStore } from './MultiFloorStore';

interface FloorManagerState {
  myFloorPid: string | null;
  floorPids: Set<string>;

  markMyFloor: (pid: string) => void;
  getMyFloorPid: () => string | null;
  listFloorPids: () => string[];

  addFloor: (pid: string) => void;
  hasFloor: (pid: string) => boolean;

  loadMyFloor: (pid: string) => Promise<void>;
  removeFloorPid: (pid: string) => void;
  resetState: () => void;
}

export const useFloorManagerStore = create<FloorManagerState>((set, get) => ({
  myFloorPid: null,
  floorPids: new Set(),

  markMyFloor: (pid) => set({ myFloorPid: pid }),

  getMyFloorPid: () => get().myFloorPid,

  listFloorPids: () => Array.from(get().floorPids),

  hasFloor: (pid) => get().floorPids.has(pid),

  addFloor: (pid) => {
    if (!get().floorPids.has(pid)) {
      set((state) => {
        const newSet = new Set(state.floorPids);
        newSet.add(pid);
        return { floorPids: newSet };
      });
      useMultiFloorStateStore.getState().addFloorState(pid);
    }
  },

  loadMyFloor: async (pid) => {
    const floorStore = useMultiFloorStateStore.getState();
    get().addFloor(pid);
    await floorStore.loadInitialState(pid);
    get().markMyFloor(pid);
  },

  removeFloorPid: async (pid: string) => {
    if (get().floorPids.has(pid)) {
      const res = Array.from(get().floorPids).filter((fpid) => fpid != pid);
      set(() => {
        return { floorPids: new Set(res) };
      });
    }
  },

  resetState: () => {
    useMultiFloorStateStore.getState().resetState();
    set(() => ({ myFloorPid: null, floorPids: new Set() }));
  },
}));
